var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBuzzer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 55,
    viewBox: "0 0 35 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.4395 6.93689C34.4395 10.768 26.73 13.8738 17.2198 13.8738C7.70953 13.8738 0 10.768 0 6.93689C0 3.10577 7.70953 0 17.2198 0C26.73 0 34.4395 3.10577 34.4395 6.93689ZM17.2198 8.13291C19.5973 8.13291 21.5247 7.49036 21.5247 6.69769C21.5247 5.90502 19.5973 5.26247 17.2198 5.26247C14.8422 5.26247 12.9148 5.90502 12.9148 6.69769C12.9148 7.49036 14.8422 8.13291 17.2198 8.13291Z",
    fill: "#362C5F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.1108 13.6168C26.7159 14.9844 22.1574 15.7872 17.2198 15.7872C12.2822 15.7872 7.72364 14.9844 4.32872 13.6168C2.76291 12.986 1.22758 12.166 0 10.9902V24.6256C0 27.6164 2.3306 28.8408 4.76557 29.6791C12.836 32.4574 21.6035 32.4574 29.674 29.6791C32.1089 28.8408 34.4395 27.6164 34.4395 24.6256V10.9902C33.212 12.166 31.6766 12.986 30.1108 13.6168Z",
    fill: "#362C5F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.90625 31.7031V51.973C4.90625 53.4605 5.76288 54.6666 6.81955 54.6666C7.87622 54.6666 8.73285 53.4605 8.73285 51.973V33.1671C7.4452 32.7694 6.16807 32.2814 4.90625 31.7031Z",
    fill: "#AEA6C6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9922 33.5295V51.9922C24.9922 53.4692 25.8488 54.6667 26.9055 54.6667C27.9622 54.6667 28.8188 53.4692 28.8188 51.9922V32.1816C27.556 32.72 26.2788 33.1693 24.9922 33.5295Z",
    fill: "#AEA6C6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuzzer);
export default __webpack_public_path__ + "static/media/buzzer.9318b45f5bb3ffa9602641fd5f248f4c.svg";
export { ForwardRef as ReactComponent };